import { GsStructBorderRadius } from 'libs/shared/src/models';
import { GsFormSchema } from '../../../components';
import { borderRadiusSchemaFields } from '../basics';
import { PICTURE_DISPLAY_MODE_SCHEMA } from '../basics/picture-display-mode.schema';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { Mode, SWIPER_WITH_GRID_SCHEMA_FIELDS } from './../basics/swiper.schema';
import { SPACING_SCHEMA } from './spacing.schema';

export const GALLERY_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'galleryImageHeight',
      label: 'components.gallery.schema.galleryImageHeight',
      description: 'components.gallery.schema.galleryImageHeightDescription',
      type: 'number',
      isResponsive: true,
      default: {
        default: 347
      }
    },
    ...PICTURE_DISPLAY_MODE_SCHEMA,
    {
      formControlName: 'showCaptions',
      label: 'components.gallery.schema.showCaptions',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'enableLightbox',
      label: 'components.gallery.schema.enableLightbox',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'itemZoomOnHover',
      label: 'components.image.schema.zoomOnHover',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'emptyMessage',
      label: 'components.gallery.schema.emptyMessage',
      type: 'text',
      default: 'components.gallery.noItems'
    },
    {
      formControlName: 'mode',
      label: 'schema.displayMode.name',
      type: 'select',
      valueType: 'number',
      default: Mode.GRID,
      options: [
        { text: 'schema.displayMode.grid', value: Mode.GRID },
        { text: 'schema.displayMode.slider', value: Mode.SLIDER }
        // TODO: implement masonry layout
        // { text: 'schema.displayMode.masonry', value: Mode.MASONRY }
      ]
    },
    ...SWIPER_WITH_GRID_SCHEMA_FIELDS,
    ...borderRadiusSchemaFields('ItemImage', GsStructBorderRadius.none, 'schema.border.name')
  ]
};
